import {useState} from 'react';

function Card({id,name,info,image,price,removeTour}){
    const[readmore,setReadmore] = useState(false);
    const description = readmore ? info : `${info.substring(0,200)}....`
    function readmoreHandler() {
        setReadmore(!readmore);
    }
    return (
    
        <div className='w-[400px] max-h-max m-[1rem] flex flex-col item-center p-[1rem] rounded-xl shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)]'>
            <img src={image} className="w-[380px] aspect-square object-cover" alt=""></img>
            <div className="my-[20px] mx-[5px]">
                <div>
                    <h4 className='text-[#1faa59] text-xl'>₹{price}</h4>
                    <h4 className='text-2xl'>{name}</h4>
                </div>
                
                <div>
                    {description}
                    <span onClick={readmoreHandler} className="text-[#12b0e8] cursor-pointer">
                        {readmore ? 'Show Less':'Read More'}
                    </span>
                </div>
            </div>
            
                <button onClick={()=>removeTour(id)}   className='mt-[18px] py-[10px] px-[80px] cursor-pointer border border-solid border-[#b4161b] rounded-xl bg-[#b4161b21] font-bold text-lg hover:bg-red-500 hover:text-white hover:transition-all'>Not Interested</button>
        </div>

    );
}
export default Card;